<template>
	<div>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12 sm12 md12 lg12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Contraseña Nueva"
							required
							type="password"
							v-model="$v.model.newPassword.$model"
							:error="$v.model.newPassword.$error"
						>
						</v-text-field>
						<span class="form-group__message" v-if="!$v.model.newPassword.required">
							Este campo es requerido.
						</span>
					</v-flex>
					<v-flex xs12 sm12 md12 lg12>
						<v-text-field
							autocomplete="off"
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Repetir contraseña Nueva"
							required
							type="password"
							v-model="$v.model.repeatPassword.$model"
							:error="$v.model.repeatPassword.$error"
						>
						</v-text-field>
						<span class="form-group__message" v-if="!$v.model.repeatPassword.sameAsPassword">
							Las contraseñas no coinciden.
						</span>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators';

function data() {
	return {
		countries: [],
		loading: false,
		model: {
			newPassword: '',
			repeatPassword: '',
		},
	};
}

function closeModal() {
	this.goTo('page-user');
}

async function submitForm() {
	const params = {
		codeCompany: this.$route.params.idCompany,
		codeProject: this.codeProject,
		password: this.model.newPassword,
	};
	const url = `users/${this.userId}/password`;
	this.loading = true;
	try {
		await this.$http.put(url, params);
		this.goTo('page-user');
		this.showNotification('La contraseña se modificó correctamente.', 'success');
	} catch (err) {
		this.showError('Ocurrió un error con el servidor');
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		model: {
			newPassword: {
				required,
			},
			repeatPassword: {
				required,
				sameAsPassword: sameAs('newPassword'),
			},
		},
	};
	return validation;
}

export default {
	name: 'users-form-change',
	data,
	methods: {
		closeModal,
		submitForm,
	},
	props: {
		userId: {
			type: String,
		},
		codeProject: {
			type: String,
		},
	},
	validations,
};
</script>


// WEBPACK FOOTER //
// src/components/users/users-form-change-password.vue